import React from "react";

import "./SmallCaption.css";

const SmallCaption = ({ text, color = "#000000" }) => (
  <small className="SmallCaption" style={{ color }}>
    {text}
  </small>
);

export default SmallCaption;
